module.exports = __webpack_public_path__ + "static/media/17.5bb0d5db.jpg";